// ── shareState ────────────────────────────────────────────────────────────────
// The words on a "Share the card" button through its life. shareCard() renders a
// 1080×1350 canvas (poster fetch + fonts) before the share sheet opens, and three
// surfaces (Wrap, Final Cut, Season Wrap) showed nothing for that second: the
// friction telemetry logged a dead tap on one (2026-10-26). Same vocabulary as the
// keepsake button already used. Pure; useShareCard owns the timing.
export const SHARE_LABELS = {
  idle: 'Share the card',
  rendering: 'Rendering…',
  shared: 'Shared',
  saved: 'Saved to your device',
  cancelled: 'Share the card',
  failed: 'Couldn’t build the card',
}
export const SHARE_SETTLE_MS = 2200
export const shareLabel = (state) => SHARE_LABELS[state] || SHARE_LABELS.idle
// Which outcomes deserve a beat on the button before it resets.
export const shareLingers = (state) => state === 'saved' || state === 'shared' || state === 'failed'
